export default "__VITE_ASSET__B_iy27vg__"